module.exports = __webpack_public_path__ + "static/media/bliss-about-section.b2630387.png";